import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/home'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/waring',
      name: 'waring',
      component: () => import('@/view/waring')
    }, {
      path: '/waring2',
      name: 'waring2',
      component: () => import('@/view/waring2')
    },
    {
      path: '/content',
      name: 'content',
      component: () => import('@/view/content')
    },
    {
      path: '/result',
      name: 'result',
      component: () => import('@/view/result')
    }, {
      path: '/result2',
      name: 'result2',
      component: () => import('@/view/result2')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/login')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/login')
    },
    {
      path: '/approve',
      name: 'approve',
      component: () => import('@/view/approve')
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js